import { FetchedStockInterface } from 'lib/hooks/useStockStore'
import { createContext, useContext } from 'react'

export const ExistingStockContext = createContext<{
  stockState: FetchedStockInterface | null
  loadStock: () => void
}>({
  stockState: { stock: [], sealedStock: [], fetchedAt: new Date().toISOString() },
  loadStock: () => undefined,
})

export const useExistingStockContext = () => {
  const state = useContext(ExistingStockContext)

  return state
}
